import { useCallback } from 'react';

import type { ExtendedUserMenuData, UserMenuData } from '../../../../common/types';
import { useUserMenuDataShapes } from '../../../../controllers/user-state/user-menu-data-shapes-provider';
import type { CustomizationModalProps } from '../../../customization-modal/types';

export const useOnSave = (): CustomizationModalProps['onSave'] => {
	const { setUserMenuData } = useUserMenuDataShapes();

	return useCallback(
		async (
			updatedItemExtendedUserMenuData: ExtendedUserMenuData,
			updatedShortcutExtendedUserMenuData: ExtendedUserMenuData,
		) => {
			// Put the data back together and remove extra properties
			const userMenuData: UserMenuData = updatedItemExtendedUserMenuData
				.concat(updatedShortcutExtendedUserMenuData)
				.map(({ menuId, visible }) => ({ menuId, visible }));

			await setUserMenuData(userMenuData);
		},
		[setUserMenuData],
	);
};
